export default __webpack_public_path__ + "static/media/img-intro-overview-ko@3x.8354a065.png";